import "./Header.css";

const Header = () => {
  return (
    <header>
      <div className="container">
        <div className="col-md-6">
          <h2>good food choice are good investement</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit
            vel illum molestiae, sit maiores autem?
          </p>
          <button>order now</button>
          <button>learn more</button>
        </div>
      </div>
    </header>
  );
};

export default Header;
